import { FC } from 'react';
import { Outlet } from 'react-router';
import classNames from 'classnames';
import { HeaderInner } from '../components/Header/HeaderInner';
import './styles.css';
import { Footer } from './components/Footer';
import { WrapperWithSidebar } from './components/WrapperWithSidebar';
import { FullScreenContainer } from './components/FullScreenContainer/FullScreenContainer';
import { Header } from '../components/Header/Header';
import Snowfall from 'src/components/Snowfall';
import { isShowEvent } from 'src/config/event/utils';
import { GPTBanners } from 'src/modules/gptBanners/components/GPTBanners';
import { useHideOnPaths } from 'src/hooks/useHideOnPaths';

export const Layout: FC = () => {
  const showSnowFall = isShowEvent('XMAS');
  const shouldHide = useHideOnPaths(['faq', 'info_pages'])  

  return (
    <FullScreenContainer>
      {showSnowFall && <Snowfall />}
      <Header hideHeaderInDesctopView additionalClassName={classNames('z-[600]')}>
        <HeaderInner />
      </Header>
      <WrapperWithSidebar>
        <div className="w-full flex flex-col justify-start items-center">
          <Outlet />
          <Footer />
        </div>
        {!shouldHide && <GPTBanners />}
      </WrapperWithSidebar>
    </FullScreenContainer>
  );
};
